import { MuiTelInput } from 'mui-tel-input';
import { useMemo } from 'react';

import { Grid, MenuItem, TextField, Typography } from '@/ui';

import { getTimezoneOptions } from '../../timezoneOptions';

import type { ChangeEvent, FC } from 'react';

import LockCard from '@/components/Profile/Card/Lock';

interface EditCoachAccountDetailsProps {
  capacity?: number | null;
  email: string;
  onPhoneChange: (
    phoneValue: string,
    phoneE164: string,
    phoneNationalNumber: string,
    reason: 'country' | 'input',
  ) => void;
  onTimezoneChange: (value: string) => void;
  phoneHelperText?: string;
  phoneInvalid?: boolean;
  phone?: string;
  timezone?: string;
}

const EditCoachAccountDetails: FC<EditCoachAccountDetailsProps> = ({
  email,
  capacity = 0,
  phone = '',
  phoneHelperText = '*Required to use SMS notifications',
  phoneInvalid = false,
  timezone = '',
  onTimezoneChange,
  onPhoneChange,
}) => {
  const timezoneItems = useMemo(
    () =>
      getTimezoneOptions().map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      )),
    [],
  );
  const onTimezone = (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
    onTimezoneChange(e.target.value);

  return (
    <Grid spacing={4} container>
      <Grid md={5} xs={12} item>
        <Typography className="mb-2" variant="h4">
          Account details
        </Typography>
        <Typography className="mb-1" variant="body1">
          To request a change to your coaching capacity, please contact&nbsp;
          <a
            className="font-bold text-cement-600"
            href="mailto:coachsupport@mento.co?subject=Coaching Capacity"
          >
            coachsupport@mento.co
          </a>
          .
        </Typography>
      </Grid>
      <Grid className="mt-1 flex flex-col gap-3" md={7} xs={12} item>
        <LockCard icon="mail" title={email} />
        <LockCard icon="communities" title={`Capacity ${capacity}`} />
        <div className="mt-2 flex flex-col gap-4">
          <TextField
            label="Default timezone"
            placeholder="Default timezone"
            value={timezone}
            select
            onChange={onTimezone}
          >
            {timezoneItems}
          </TextField>
          <MuiTelInput
            defaultCountry="US"
            error={phoneInvalid}
            helperText={phoneHelperText}
            label="Phone"
            placeholder="Phone"
            value={phone || ''}
            forceCallingCode
            fullWidth
            onChange={(value, info) => {
              onPhoneChange(
                value || '',
                info.numberValue || '',
                info.nationalNumber || '',
                info.reason,
              );
            }}
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default EditCoachAccountDetails;
